import { useState } from "react";
import useAppStore from "../../store/AppStore";
import styles from "./SkipContinueButton.module.css";
import useComponentsStore from "../../store/componentsStateStore";
import { getGeneralImage, styleHelper } from "../../helpers/commonFunctions";
import {ContinueButtonData} from "../../interfaces/continueButton/ContinueButton.type";
const Button = ({ item, colSize }: { item: ContinueButtonData , colSize: string}) => {
    const contentBox = item?.contentBox;
    const payLoad = item?.payload;
    const status = item?.status;
    const { isDeviceMobile } = useAppStore();
    const [isLoading, setIsLoading] = useState(false);
    const { continueDraft } = useComponentsStore();

    const onClickHandler = async () => {
        if (status === false || isLoading) return;
        try {
            setIsLoading(true);
            await continueDraft(payLoad);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
            window.scrollTo({
                top: 0,
                behavior: 'auto' // Optional: use 'auto' if you want instant scrolling
            });
        }
    };
    return (
            <button
                className={`vas-text-18 vas-btn ${colSize} vas-fw-bold vas-d-flex vas-align-items-center vas-justify-content-between vas-border-radius ${
                    styles.sticky_button
                } ${
                    !isDeviceMobile ? `${styles.p_25}` : `vas-btn-md ${styles.p_25}`
                }`}
                style={styleHelper({
                    backgroundColor: item?.backgroundColor,
                    border: item?.borderColor ? `2px solid ${item?.borderColor}` : '0px'
                })}
                onClick={onClickHandler}
            >
      <span className={`vas-gap-1 ${styles.centered_content} vas-align-items-center vas-justify-content-center`}>

          <span style={styleHelper({color: contentBox?.textColor})}>
          {contentBox?.text}{" "}
        </span>
          {contentBox?.icon ? (
              <img
                  className="vas"
                  src={getGeneralImage(contentBox?.icon)}
                  alt="sticky_icon"
                  height={30}
                  width={30}
              />
          ) : (<></>)}
      </span>
            </button>
    );
};

export default Button;
